import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import theme from './theme';
import { ApiStateProvider } from './context/ApiStateContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import Home from './pages/Home';
import CusipPage from './pages/CusipPage';
import ShareholderPage from './pages/ShareholderPage';
import FtpPage from './pages/Ftp';
import UploadFileScheduler from './pages/UploadFileScheduler';
import ContentHub from './pages/ContentHub';
import ApiPage from './pages/ApiPage';
import VotrAccessPage from './pages/VotrAccessPage';
import DetailsPage from './pages/DetailsPage';
import SettingsPage from './pages/SettingsPage';
import Dashboard from './pages/Dashboard';
import Portfolio from './pages/Portfolio';

const App: React.FC = () => {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <AuthProvider>
                <ApiStateProvider>
                    <Router>
                        <Routes>
                            {/* Public routes */}
                            <Route path="/login" element={<LoginPage />} />

                            {/* Protected routes */}
                            <Route path="/" element={
                                <ProtectedRoute>
                                    <Home />
                                </ProtectedRoute>
                            }>
                                <Route path="cusips" element={<CusipPage />} />
                                <Route path="shareholders" element={<ShareholderPage />} />
                                <Route path="ftps" element={<FtpPage />} />
                                <Route path="upload-scheduler" element={<UploadFileScheduler />} />
                                <Route path="content-hub" element={<ContentHub />} />
                                <Route path="dashboard" element={<Dashboard />} />
                                <Route path="portfolio" element={<Portfolio />} />
                                <Route path="api" element={<ApiPage />} />
                                <Route path="votr-access" element={<VotrAccessPage />} />
                                <Route path="settings" element={<SettingsPage />} />
                                <Route path="details/:company" element={<DetailsPage />} />
                                <Route index element={<CusipPage />} />
                            </Route>
                        </Routes>
                    </Router>
                </ApiStateProvider>
            </AuthProvider>
        </ThemeProvider>
    );
};

export default App;
